import React from 'react'

import { GenericError } from '@sketch/components'

import { PublicationQueryPreferencesFragment } from '@sketch/gql-types'

import { PublicationGridPlaceholder } from '../PublicationGrid'
import PublicationSlider from '../PublicationSlider'
import { useGetCommunityPublications } from '../../hooks/useGetCommunityPublications'

interface CommunityPublicationSliderProps {
  preferences: PublicationQueryPreferencesFragment | null
}

const CommunityPublicationSlider = (props: CommunityPublicationSliderProps) => {
  const { preferences } = props

  const { data, loading, error } = useGetCommunityPublications({
    preferences,
  })

  if (loading) {
    return <PublicationGridPlaceholder />
  }

  if (error || !data) {
    return <GenericError />
  }

  const publications = data.publications
  const items = publications.entries || []

  return <PublicationSlider items={items} />
}

export default CommunityPublicationSlider
